export enum ServiceInvoicingType {
  ByHour = "byHour",
  ByService = "byService",
}
